import React from 'react';
import { FormTextField } from '@uncinc/uncinc-react-kitchen-sink';
import useClasses from '../../../hooks/useClasses';

interface Props {
  title: string;
  required?: boolean;
  description?: string;
  placeholder?: string;
  fieldName: string;
  className?: string;
  wrapperClassName?: string;
  disabled?: boolean;
}

const PasswordField: React.FC<Props> = ({
  className,
  wrapperClassName,
  ...props
}) => {
  const { buildClass: buildWrapperClass, joinClasses } = useClasses('PasswordField');
  const { buildClass: buildInputClass } = useClasses('input', 'password');

  return (
    <FormTextField
      type="password"
      wrapperClassName={joinClasses(buildWrapperClass(), wrapperClassName)}
      className={joinClasses(buildInputClass(), className)}
      {...props}
    />
  );
};

export default PasswordField;
